// extracted by mini-css-extract-plugin
export default {"grid":"RoleList_grid__pzHMn","chip":"RoleList_chip__7f7gx"};